module.exports = __webpack_public_path__ + "img/bingo_ball-72.a5212469.png";